<template>
  <!--账号申请-->
  <tk-container :status="status">
    <!--页面头部-->
    <my-header slot="header" class="font-bold">账号申请</my-header>
    <!--账号申请表单-->
    <tkui-form ref="form">
      <div class="account-basic">
        <!--姓名-->
        <div class="account-basic-input">
          <tkui-input v-model="name" rulers="required" label="姓名" placeHolder="请输入您的真实姓名"></tkui-input>
        </div>
        <!--手机号码-->
        <div class="account-basic-input">
          <tkui-input v-model="phone" rulers="mobile" label="手机号码" placeHolder="请输入您的常用号码"></tkui-input>
        </div>
        <!--经营类型-->
        <div class="account-basic-enter">
          <tk-flex
            between
            middle
            class="tkui-list-item"
            @click.native="typeShow = true"
          >
            <tk-flex class="list-item-content full-width">
              <div style="width: 88px;font-size: 14px;">经营类型</div>
              <div
                class="tkui-list-picker-body empty"
                style="text-align: left;"
                v-if="!businessType.length"
              >请选择</div>
              <tk-flex
                class="tkui-list-picker-body"
                style="text-align: left;"
                gutter="5"
                v-else
              >
                <div
                  v-for="(s, index) in typeRender"
                  :key="index"
                >{{s}}</div>
              </tk-flex>
            </tk-flex>
            <div><tk-icon size="21" material>keyboard_arrow_down</tk-icon></div>
          </tk-flex>
          <tk-cover
            bottom
            transition
            :show.sync="typeShow"
          >
            <tk-flex column class="tkui-picker">
              <tk-flex between class="full-width picker-action">
                <button class="action-button" @click="typeShow = false">取消</button>
                <button class="action-button selected" @click="sureType">确定</button>
              </tk-flex>
              <tkui-list-select style="width: 100vw;" type="checkbox" v-model="cloneType" :items="typeObj"></tkui-list-select>
            </tk-flex>
          </tk-cover>
        </div>
        <!--门店名称-->
        <div class="account-basic-input p-l-15">
          <tkui-input rulers="required" v-model="storeName" label="门店名称" placeHolder="填写简称即可"></tkui-input>
        </div>
        <!--门店地址-->
        <div class="account-basic-enter">
          <tkui-list>
            <tkui-list-picker type="region" v-model="region" left label="门店地址" :regionFilter="regionFilter" placeholder="请选择"></tkui-list-picker>
          </tkui-list>
        </div>
        <!--详细地址-->
        <div class="account-basic-input account-basic-detail p-l-15">
          <div class="compatible-input font-14 p-t-16" style="font-weight: 500;">详细地址</div>
          <tkui-input rulers="required" v-model="storeAddress" label="" placeHolder="默认收货地址，请您详细填写"></tkui-input>
        </div>
        <!--门店照片-->
        <div class="account-basic font-12">
          <tk-flex column class="p-15 account-basic-bg">
            <div class="m-b-12 font-14">门店照片</div>
            <tk-flex class="m-b-5" gutter="15">
              <tk-flex
                column center
                class="account-basic-bg-box"
                @click.native="uploadPics('panoramicPhotos')"
              >
                <tk-flex center middle v-if="panoramicWaiting" class="account-basic-bg-box-img">
                  <div class="item">
                    <tk-spinner type="oval" color="rgba(153, 153, 153, 1)" size="25"></tk-spinner>
                  </div>
                </tk-flex>
                <tk-image v-else-if="panoramicPhotos" :src="panoramicPhotos" quality="100" width="80" height="80"></tk-image>
                <tk-flex
                  center middle
                  v-else
                  class="account-basic-bg-box-img"
                >
                  <tk-icon size="26" color="#fff">camera</tk-icon>
                </tk-flex>
                <div class="account-basic-bg-box-text m-t-10">店外全景照</div>
              </tk-flex>
              <tk-flex
                column center
                class="account-basic-bg-box"
                @click.native="uploadPics('inStorePhotos')"
              >
                <tk-flex center middle v-if="inStoreWaiting" class="account-basic-bg-box-img">
                  <div class="item">
                    <tk-spinner type="oval" color="rgba(153, 153, 153, 1)" size="25"></tk-spinner>
                  </div>
                </tk-flex>
                <tk-image v-else-if="inStorePhotos" :src="inStorePhotos" quality="100" width="80" height="80"></tk-image>
                <tk-flex
                  center middle
                  v-else
                  class="account-basic-bg-box-img"
                >
                  <tk-icon size="26" color="#fff">camera</tk-icon>
                </tk-flex>
                <div class="account-basic-bg-box-text m-t-10">店内全景照</div>
              </tk-flex>
            </tk-flex>
          </tk-flex>
        </div>
      </div>
    </tkui-form>
    <!--提交账号申请-->
    <div class="contentBtn">
      <tk-flex middle class="font-13 primary">
        <tk-icon size="16" color="#D51613" style="margin-bottom: -4px;">prompt</tk-icon>
        <div class="font-13 m-l-8">提示</div>
      </tk-flex>
      <div
        class="m-t-12 font-13 m-b-30"
        style="color: #999;"
      >我们将在24小时内，与您联系进行信息验证，通过即可开通登录权限，请耐心等候。</div>
      <tkui-button
        :disabled="applyDisabled"
        @click="applyNow"
        class="raised primary block rounded surePrint"
      >提交</tkui-button>
    </div>
    <!--注册成功提示-->
    <tkui-dialog :show.sync="applyShow" center hideAction closeIcon timeout="3000">
      <tk-icon material size="64">check</tk-icon>
      <div class="subhead">
        您的申请已提交
      </div>
      <p class="caption">请耐心等待</p>
    </tkui-dialog>
  </tk-container>
</template>

<script>
export default {
  data () {
    return {
      status: false, // 页面状态
      applyShow: false, // 提交成功提示
      applyDisabled: false, // 按钮提交状态
      regionFilter: { // 地理位置
        root: '130000'
      },
      name: '', // 姓名
      phone: '', // 电话
      region: '', // 所在地区
      storeName: '', // 门店名称
      typeObj: { // 经营类型数据
        car: '整车',
        accessories: '配件',
        maintenance: '维修'
      },
      typeShow: false, // 经营类型显示
      cloneType: [], // 选定的经营类型
      businessType: [], // 选定的经营类型
      storeAddress: '', // 门店地址
      inStorePhotos: null, // 店内全景照片
      inStoreWaiting: false, // 店内照片上传状态
      panoramicPhotos: null, // 店外全景照片
      panoramicWaiting: false // 店外照片上传状态
    }
  },
  computed: {
    // 渲染经营类型
    typeRender () {
      if (!this.businessType.length) { return [] }
      return this.businessType.map(s => {
        let text = ''
        if (s === 'car') { text = '整车' }
        if (s === 'accessories') { text = '配件' }
        if (s === 'maintenance') { text = '维修' }
        return text
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  mounted () {
    this.setStatusBar('dark')
  },
  methods: {
    /**
    * 选择经营类型 确定
    * @date: 2020/3/19
    */
    sureType () {
      this.businessType = this.cloneType
      this.typeShow = false
    },
    /**
    * 上传图片
    * @prams type {string} 类型
    *  @inStorePhotos 店内照片 inStoreWaiting 店内照片上传状态
    *  @panoramicPhotos 店外全景照片 panoramicWaiting 店内照片上传状态
    * @date: 2020/3/19
    */
    async uploadPics (type) {
      if (type === 'inStorePhotos' && this.inStoreWaiting) { return this.$tkGlobal.toast.add('您点的太快了') }
      if (type === 'panoramicPhotos' && this.panoramicWaiting) { return this.$tkGlobal.toast.add('您点的太快了') }
      // 校验格式
      let file = await this.$tkFile.pick({
        type: 'image/*',
        from: 'camera' })
      // 提交图片，更新view
      try {
        if (type === 'inStorePhotos') { this.inStoreWaiting = true }
        if (type === 'panoramicPhotos') { this.panoramicWaiting = true }
        let res = await this.$tkParse.post('/files', file.buffer)
        await this.$tkHelper.sleep(1000)
        switch (type) {
          case 'inStorePhotos':
            this.inStorePhotos = res.data.url
            break
          case 'panoramicPhotos':
            this.panoramicPhotos = res.data.url
            break
        }
        if (type === 'inStorePhotos') { this.inStoreWaiting = false }
        if (type === 'panoramicPhotos') { this.panoramicWaiting = false }
      } catch (e) {
        if (type === 'logo') { this.inStoreWaiting = false }
        if (type === 'licenseImage') { this.panoramicWaiting = false }
        this.$tkGlobal.toast.add('请重新上传')
      }
    },
    /**
    * 验证数据表中是否已有此账号信息
    * @params phone {string}
    * @date: 2020/3/19
    */
    async verifyAccount (className, phone) {
      let res = await this.$tkParse.getList(`/classes/${className}`, { params: { limit: 1, where: { phone: phone } } })
      return res.length
    },
    /**
    * 要提交的数据
    * @date: 2020/3/19
    */
    applyData () {
      return {
        name: this.name,
        phone: this.phone,
        region: this.region,
        storeName: this.storeName,
        businessType: this.businessType,
        storeAddress: this.storeAddress,
        inStorePhotos: this.inStorePhotos,
        panoramicPhotos: this.panoramicPhotos,
        permissionStatus: 'pendingReview'
      }
    },
    /**
    * 提交申请
    * @date: 2020/3/19
    */
    async applyNow () {
      let res = this.$refs.form.validate()
      if (!this.inStorePhotos) { res.push('inStorePhotos') }
      if (!this.panoramicPhotos) { res.push('panoramicPhotos') }
      if (!this.businessType.length) { res.push('businessType') }
      if (!this.region) { res.push('region') }
      if (res.length > 0) {
        this.$tkGlobal.toast.add('请检查您填写的内容是否正确')
        return
      }
      this.applyDisabled = true
      let verifySum = await this.verifyAccount('applicationRecord', this.phone)
      let verifyUserSum = await this.verifyAccount('_User', this.phone)
      if (verifySum > 0 || verifyUserSum > 0) {
        this.status = false
        this.applyDisabled = false
        this.$tkGlobal.toast.add('已有您的注册信息，暂不能注册')
        return
      }
      await this.$tkParse.post(`/classes/applicationRecord`, this.applyData()).catch(() => {
        this.status = false
        this.applyDisabled = false
        throw this.$tkGlobal.toast.add('提交账号申请失败')
      })
      this.$replace('/common/login')
      await this.$tkHelper.sleep(500)
      this.$tkGlobal.toast.add('提交账号申请成功，请耐心等待')
      this.status = false
      this.applyDisabled = false
      this.applyShow = true
    }
  }
}
</script>

<style scoped lang="scss">
  /*表单样式*/
  .account-basic {
    /*input样式*/
    .account-basic-input {
      padding: 0 15px;
      background-color: #ffffff;
      font-size: 14px;
      ::placeholder {
        color: rgba(191, 191, 191, 1);
      }
    }
    .account-basic-enter {
      background-color: #ffffff;
      font-size: 14px;
    }
    .account-basic-bg {
      background: #ffffff;
      border-bottom: 1px solid #f5f5f5;
      font-size: 12px;
    }
    .account-basic-bg-box{
      /*margin-left: 19px;*/
      .account-basic-bg-box-img {
        width: 80px;
        height: 80px;
        background-color: #F5F5F5;
      }
      .account-basic-bg-box-text {
        font-size: 12px;
        color: rgba(153, 153, 153, 1);
      }
    }
  }
  /*多选框样式*/
  .tkui-picker {
    .picker-action {
      padding: 8px 15px;
      background: #fff;
      border-radius: 10px 10px 0 0 !important;
      border-bottom: 1px solid #f5f5f5;
      .action-button {
        padding: 8px;
      }
      .selected {
        color: #F41915;
      }
    }
  }
  /*按钮样式*/
  .contentBtn{
    margin-top: 7px;
    padding: 15px;
    .surePrint{
      padding: 0 43px;
      margin: 30px 43px;
      color: #fff;
    }
  }
  ::v-deep .tkui-list-item {
    margin-left: 15px;
    margin-right: 15px;
  }
  ::v-deep .account-basic-detail .tkui-input-container .tkui-input-body-warp .tkui-input-body {
    margin-top: 8px !important;
  }
  ::v-deep .tkui-list-item .left {
    padding-right: 12px !important;
  }
  ::v-deep .tkui-list-picker-icon {
    width: 20px;
    height: 20px;
  }
</style>
